import React from "react";
import QRCode from "qrcode";
import { jsPDF } from "jspdf";
import Bunexe_service from "../Bunexe_service";

// import "./App.css";
import { useState } from "react";
import { toast } from "react-toastify";
//const jsPDF = require("jspdf");

const Ediplome = () => {
  const [imageurl, setImageurl] = useState();
  const [matricule, setMatricule] = useState("");
  const [resultat, setResultat] = useState([]);
  const [name, setName] = useState("");

  let url_ = Bunexe_service.url;

  const printReleve = (
    img_,
    identifiant,
    nom,
    prenom,
    annee,
    dnaiss_,
    lieu_,
    matricule,
    moy,
    section_,
    session_,
    Section_lib,
    sexe_,
    notes
  ) => {
    const doc = new jsPDF(); //, "mm", "letter");
    doc.setFont("helvetica", "bold");
    let Entete = "MINISTERE DE L'EDUCATION NATIONALE";
    let Entete2 = "ET DE LA FORMATION PROFESSIONNELLE";

    doc.addImage("armoirie.jpeg", "jpeg", 86, 10, 30, 30);

    doc.text(Entete, 38, 46, { charSpace: "0.8" });
    doc.text(Entete2, 38, 54, { charSpace: "0.7" });

    doc.setFont("helvetica", "bold");
    let diplome = "DIRECTION GENERALE";
    doc.text(diplome, 64, 64, { charSpace: "0.7" });
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    let releve = "RELEVE DE NOTES";
    doc.text(releve, 70, 78, { charSpace: "0.7" });

    // let An_ = annee;
    // doc.setFontSize(50);
    // doc.setFont("helvetica", "bold");
    // doc.text(An_, 30, 120, null, 90);
    // doc.text(text, 52, 40);

    doc.addImage(img_, "png", 150, 54, 30, 30);
    //doc.output("datauri");
    doc.setFontSize(30);
    doc.setFont("helvetica", "bold");
    let nom_ = nom.trim() + " " + prenom.trim();
    //doc.text(nom_, 144, 82, null, null, "center");

    doc.setFont("times", "normal");
    doc.setFontSize(12);
    let dnaiss = dnaiss_; //"15 Juillet 1978";
    let lieu = lieu_; //"Port-au-Prince";
    let sexe = sexe_ === "1" ? "Monsieur" : "Mademoiselle";
    //let ligne1 = `Né(e) le ${dnaiss} à ${lieu}`;

    //doc.text(ligne1, 60, 100, { charSpace: "0.7" });
    //let periode = " Juillet " + An_;
    let section = "";
    if (
      session_ == "T" ||
      session_ == "U" ||
      session_ == "V" ||
      session_ == "X"
    ) {
      //let s = Bunexe_service.serie.filter((s) => s.Code_serie == section_)[0];
      section = "UNIQUE, Secondaire IV à la série " + Section_lib;
    } else {
      section =
        "Secondaire, Section " + section_.substr(section_.length - 1, 1);
    }

    let textbb1 = ` La Direction Génerale du Ministere de l'Education Nationale et de la`;
    let textbb2 = `Formation Professionnelle certifie que ${sexe} ${nom}`;
    let textbb3 = `${prenom.trim()} né(e) le ${dnaiss} à ( au, aux ) ${lieu},`;
    let textbb4 = `Enregistré(e) au N0. ${matricule}, a participé aux Examens `;
    textbb4 +=
      session_ == "T" || session_ == "U" || session_ == "V" || session_ == "X"
        ? "du BAC "
        : "de fin d'études ";
    let textbb5 = ` session de :`;
    let textbb6 = `${section} et a obtenu les notes suivantes pour la session de `;
    let splitTitle = doc.splitTextToSize(textbb6, 160);
    //let ligne2 = `a obtenu à la session de `; //${periode} ,le diplôme de fin d'études secondaires`;
    doc.text(textbb1, 15, 90, { charSpace: "0.7", align: "justify" });
    doc.text(textbb2, 15, 96, { charSpace: "0.7", align: "justify" });
    doc.text(textbb3, 15, 102, { charSpace: "0.7", align: "justify" });
    doc.text(textbb4, 15, 108, { charSpace: "0.7", align: "justify" });
    // doc.text(textbb5, 24, 112, { charSpace: "0.7" }, "left");
    if (
      session_ == "T" ||
      session_ == "U" ||
      session_ == "V" ||
      session_ == "X"
    ) {
      doc.text(`${section} et `, 15, 114, {
        charSpace: "0.7",
        align: "justify",
      });
      doc.text(
        `a obtenu les notes suivantes pour la session de `,
        15,
        120,
        { charSpace: "0.7" },
        "left"
      );
    } else {
      doc.text(splitTitle, 15, 114, { charSpace: "0.7", align: "justify" });
    }

    let debut = 134;
    let lineheight = 10;
    doc.setFont("helvetica", "bold");
    doc.text("MATIÈRES", 44, 131, { charSpace: "0.7" });
    doc.text("NOTES", 120, 131, { charSpace: "0.7" });
    doc.setFont("times", "normal");
    notes.forEach((n) => {
      if (n.matiere !== "") {
        console.log(n);
        debut += lineheight;
        doc.text(n.matiere, 44, debut, { charSpace: "0.7" });
        doc.text(
          n.note.padStart(3, " ") + "   /   " + n.coef,
          120,
          debut,
          { charSpace: "0.3" },
          "right"
        );
      }
    });

    // let section = "";
    // if (
    //   session_ == "T" ||
    //   session_ == "U" ||
    //   session_ == "V" ||
    //   session_ == "X"
    // ) {
    //   //let s = Bunexe_service.serie.filter((s) => s.Code_serie == section_)[0];
    //   section = Section_lib;
    // } else {
    //   section = "Section " + section_.substr(section_.length - 1, 1);
    // }

    // doc.setFont("helvetica", "bolditalic");
    // doc.setFontSize(26);
    // doc.text(section, 144, 130, null, null, "center");
    // let num = matricule; //"0100009876";
    // let numero = `numéro d'enregistrement :${num}`;
    // doc.setFont("times", "normal");
    // doc.setFontSize(12);
    // doc.text(numero, 60, 144, { charSpace: "0.7" });

    // let fait_a = `Fait à Port-au-Prince ,`;
    // doc.setFont("times", "bold");
    // doc.setFontSize(12);
    // doc.text(fait_a, 180, 144, { charSpace: "0.7" });

    // let delegation = "Par délégation du ministre";
    // let direction_generale = "La direction génerale";
    // doc.setFont("helvetica", "bold");
    // doc.text(delegation, 144, 166, null, null, "center");
    // doc.text(direction_generale, 144, 172, null, null, "center");

    let dir_bunexe = "Le Directeur du Bureau";
    let bunexe = "National des Examens d'Etat";
    doc.setFont("helvetica", "bold");
    doc.text(dir_bunexe, 40, 260, null, null, "center");
    doc.text(bunexe, 40, 266, null, null, "center");

    let dir_des = "Le Directeur";
    let des = "de l'Enseignement Secondaire";
    doc.setFont("helvetica", "bold");
    doc.text(dir_des, 150, 260, null, null, "center");
    doc.text(des, 160, 266, null, null, "center");

    //doc.addImage("Directeur_general_menos_jeune.jpg", "jpg", 120, 148, 50, 15);
    doc.addImage("DirBUNEXE_Renan.jpg", "jpg", 30, 242, 50, 15);
    doc.addImage("signature-example.png", "png", 140, 242, 30, 10);

    // experimentation
    let exp_ = "Bunexe e-relevé en expérimentation";
    doc.setFontSize(16);
    doc.setTextColor("red");
    // // doc.setFont("helvetica", "bold");
    // doc.setFont("courier", "bolditalic");
    // //doc.setFontType("bolditalic");
    doc.text(exp_, 26, 230, null, 90);

    //doc.output("dataurlnewwindow");
    // doc.save(`bunexe_e_certificat-example-${identifiant}-${nom_}.pdf`);
    if (window.screen.availWidth < 641) {
      doc.save(`bunexe_e_certificat-example-${identifiant}-${nom_}.pdf`);
    } else {
      document.getElementById("output").data = doc.output("datauristring");
    }
  };
  // QRCode.toDataURL("I am a pony!")
  //   .then((url) => {
  //     console.log(url);
  //   })
  //   .catch((err) => {
  //     console.error(err);
  //   });

  // const printPdf = (
  //   img_,
  //   identifiant,
  //   nom,
  //   prenom,
  //   annee,
  //   dnaiss_,
  //   lieu_,
  //   matricule,
  //   moy,
  //   section_
  // ) => {
  //   const doc = new jsPDF("landscape");
  //   doc.setFont("times", "normal");
  //   let Entete =
  //     "MINISTERE DE L'EDUCATION NATIONALE ET DE LA FORMATION PROFESSIONNELLE";

  //   doc.addImage("armoirie.jpeg", "jpeg", 130, 10, 30, 30);

  //   doc.text(Entete, 140, 20, null, null, "center");

  //   doc.setFont("helvetica", "bold");
  //   let diplome = "DIPLÔME DE FIN D'ETUDES SECONDAIRES";
  //   doc.text(diplome, 144, 32, null, null, "center");
  //   let An_ = annee;
  //   doc.setFontSize(50);
  //   doc.setFont("helvetica", "bold");
  //   doc.text(An_, 30, 120, null, 90);
  //   // doc.text(text, 52, 40);

  //   doc.addImage(img_, "png", 226, 24, 30, 30);
  //   //doc.output("datauri");
  //   doc.setFontSize(30);
  //   doc.setFont("helvetica", "bold");
  //   let nom_ = nom.trim() + " " + prenom.trim();
  //   doc.text(nom_, 144, 52, null, null, "center");

  //   doc.setFont("times", "normal");
  //   doc.setFontSize(12);
  //   let dnaiss = dnaiss_; //"15 Juillet 1978";
  //   let lieu = lieu_; //"Port-au-Prince";
  //   let ligne1 = `Né(e) le ${dnaiss} à ${lieu}`;

  //   doc.text(ligne1, 60, 72, { charSpace: "0.7" });
  //   let periode = " Juillet 2012";
  //   let ligne2 = `a obtenu à la session de ${periode} ,le diplôme de fin d'études secondaires`;
  //   doc.text(ligne2, 60, 82, { charSpace: "0.7" });

  //   let section = "Section " + section_.substr(section_.length - 1, 1);
  //   doc.setFont("helvetica", "bold");
  //   doc.setFontSize(30);
  //   doc.text(section, 144, 102, null, null, "center");
  //   let num = matricule; //"0100009876";
  //   let numero = `numéro d'enregistrement :${num}`;
  //   doc.setFont("times", "normal");
  //   doc.setFontSize(12);
  //   doc.text(numero, 60, 116, { charSpace: "0.7" });

  //   let fait_a = `Fait à Port-au-Prince ,`;
  //   doc.setFont("times", "bold");
  //   doc.setFontSize(12);
  //   doc.text(fait_a, 180, 116, { charSpace: "0.7" });

  //   let fait_le = `Haïti, le : 28/12/2021`;
  //   doc.setFont("times", "bold");
  //   doc.setFontSize(12);
  //   doc.text(fait_le, 180, 122, { charSpace: "0.7" });

  //   let delegation = "Par délégation du ministre";
  //   let direction_generale = "La direction génerale";
  //   doc.setFont("helvetica", "bold");
  //   doc.text(delegation, 144, 146, null, null, "center");
  //   doc.text(direction_generale, 144, 152, null, null, "center");

  //   let dir_bunexe = "Le Directeur du Bureau";
  //   let bunexe = "National des Examens d'Etat";
  //   doc.setFont("helvetica", "bold");
  //   doc.text(dir_bunexe, 80, 180, null, null, "center");
  //   doc.text(bunexe, 80, 186, null, null, "center");

  //   let dir_des = "Le Directeur";
  //   let des = "de l'Enseignement Secondaire";
  //   doc.setFont("helvetica", "bold");
  //   doc.text(dir_des, 210, 180, null, null, "center");
  //   doc.text(des, 210, 186, null, null, "center");

  //   doc.addImage("signature-example.png", "png", 130, 130, 30, 10);
  //   doc.addImage("signature-example.png", "png", 60, 164, 30, 10);
  //   doc.addImage("signature-example.png", "png", 200, 164, 30, 10);

  //   //doc.output("dataurlnewwindow");
  //   doc.save(`bunexe_e_certificat-example-${identifiant}-${nom_}.pdf`);
  // };
  //#################
  const printPdf = (
    img_,
    identifiant,
    nom,
    prenom,
    annee,
    dnaiss_,
    lieu_,
    matricule,
    moy,
    section_,
    session_,
    Section_lib
  ) => {
    const doc = new jsPDF("landscape"); //, "mm", "letter");
    doc.setFont("times", "normal");
    let Entete =
      "MINISTERE DE L'EDUCATION NATIONALE ET DE LA FORMATION PROFESSIONNELLE";

    doc.addImage("armoirie.jpeg", "jpeg", 126, 10, 30, 30);

    doc.text(Entete, 142, 46, null, null, "center");

    doc.setFont("helvetica", "bold");
    let diplome = "DIPLÔME DE FIN D'ETUDES SECONDAIRES";
    doc.text(diplome, 144, 58, null, null, "center");
    let An_ = annee;
    doc.setFontSize(50);
    doc.setFont("helvetica", "bold");
    doc.text(An_, 30, 120, null, 90);
    // doc.text(text, 52, 40);

    doc.addImage(img_, "png", 226, 50, 30, 30);
    //doc.output("datauri");
    doc.setFontSize(30);
    doc.setFont("helvetica", "bold");
    let nom_ = nom.trim() + " " + prenom.trim();
    doc.text(nom_, 144, 82, null, null, "center");

    doc.setFont("times", "normal");
    doc.setFontSize(12);
    let dnaiss = dnaiss_; //"15 Juillet 1978";
    let lieu = lieu_; //"Port-au-Prince";
    let ligne1 = `Né(e) le ${dnaiss} à ${lieu}`;

    doc.text(ligne1, 60, 100, { charSpace: "0.7" });
    let periode = " Juillet " + An_;
    let ligne2 = `a obtenu à la session de ${periode} ,le diplôme de fin d'études secondaires`;
    doc.text(ligne2, 60, 110, { charSpace: "0.7" });

    let section = "";
    if (
      session_ == "T" ||
      session_ == "U" ||
      session_ == "V" ||
      session_ == "X"
    ) {
      //let s = Bunexe_service.serie.filter((s) => s.Code_serie == section_)[0];
      section = Section_lib;
    } else {
      section = "Section " + section_.substr(section_.length - 1, 1);
    }

    doc.setFont("helvetica", "bolditalic");
    doc.setFontSize(26);
    doc.text(section, 144, 130, null, null, "center");
    let num = matricule; //"0100009876";
    let numero = `numéro d'enregistrement :${num}`;
    doc.setFont("times", "normal");
    doc.setFontSize(12);
    doc.text(numero, 60, 144, { charSpace: "0.7" });

    let fait_a = `Fait à Port-au-Prince ,`;
    doc.setFont("times", "bold");
    doc.setFontSize(12);
    doc.text(fait_a, 180, 144, { charSpace: "0.7" });

    let fait_le = `Haïti, le : 28/12/2021`;
    doc.setFont("times", "bold");
    doc.setFontSize(12);
    doc.text(fait_le, 180, 150, { charSpace: "0.7" });

    let delegation = "Par délégation du ministre";
    let direction_generale = "La direction génerale";
    doc.setFont("helvetica", "bold");
    doc.text(delegation, 144, 166, null, null, "center");
    doc.text(direction_generale, 144, 172, null, null, "center");

    let dir_bunexe = "Le Directeur du Bureau";
    let bunexe = "National des Examens d'Etat";
    doc.setFont("helvetica", "bold");
    doc.text(dir_bunexe, 80, 180, null, null, "center");
    doc.text(bunexe, 80, 186, null, null, "center");

    let dir_des = "Le Directeur";
    let des = "de l'Enseignement Secondaire";
    doc.setFont("helvetica", "bold");
    doc.text(dir_des, 210, 180, null, null, "center");
    doc.text(des, 210, 186, null, null, "center");

    doc.addImage("Directeur_general_menos_jeune.jpg", "jpg", 120, 148, 50, 15);
    doc.addImage("DirBUNEXE_Renan.jpg", "jpg", 60, 162, 50, 15);
    doc.addImage("signature-example.png", "png", 200, 164, 30, 10);

    // experimentation
    let exp_ = "Bunexe e-diplome en expérimentation";
    doc.setFontSize(16);
    doc.setTextColor("red");
    // doc.setFont("helvetica", "bold");
    doc.setFont("courier", "bolditalic");
    //doc.setFontType("bolditalic");
    doc.text(exp_, 38, 170, null, 90);

    //doc.output("dataurlnewwindow");
    // doc.save(`bunexe_e_certificat-example-${identifiant}-${nom_}.pdf`);
    if (window.screen.availWidth < 641) {
      doc.save(`bunexe_e_certificat-example-${identifiant}-${nom_}.pdf`);
    } else {
      document.getElementById("output").data = doc.output("datauristring");
    }
  };

  // With async/await
  const generateQR = async (
    type,
    identifiant,
    nom,
    prenom,
    annee,
    dnaiss,
    lieu,
    matricule,
    moy,
    section,
    session,
    Section_lib,
    sexe,
    notes
  ) => {
    // let text = `${identifiant} , ${nom} ${prenom}, ${annee},${dnaiss},${lieu}, ${matricule}, ${moy}`;
    let text = `${identifiant}`;
    try {
      let u = await QRCode.toDataURL(text);
      //console.log(text);
      // console.log(await QRCode.toDataURL(text));
      setImageurl(u);
      // console.log(nom, prenom, annee, matricule, moy);
      if (type == "C") {
        printPdf(
          u,
          identifiant,
          nom,
          prenom,
          annee,
          dnaiss,
          lieu,
          matricule,
          moy,
          section,
          session,
          Section_lib
        );
      } else {
        printReleve(
          u,
          identifiant,
          nom,
          prenom,
          annee,
          dnaiss,
          lieu,
          matricule,
          moy,
          section,
          session,
          Section_lib,
          sexe,
          notes
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  const Rechercher = async () => {
    // let url_ = "http://localhost:8086/api";
    let sc = window.screen.availWidth;
    console.log("############   Screen Size    ###############");
    console.log(sc);
    console.log("############  Fin Screen Size    ###############");

    try {
      fetch(url_ + `/dossier/an_section/${matricule}`)
        .then((response) => response.json())
        .then((data) => {
          if (data.data.length > 0) {
            // console.log(data.data);
            setResultat(data.data);
          } else
            toast.error(
              "Information non - trouvée, Veuiller consulter le numéro d'ordre du candidat",
              {
                position: toast.POSITION.TOP_RIGHT,
              }
            );
        })
        .catch((err) => console.log(err));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12 col-md-3 mt-2">
          <div class="card">
            <div class="card-body">
              <input
                type="text"
                class="form-control"
                id="name"
                placeholder="Matricule ici"
                onChange={(e) => {
                  setResultat([]);
                  setMatricule(e.target.value);
                }}
              />
              <button
                className="btn btn-sm btn-primary mt-2 "
                onClick={Rechercher}
              >
                {" "}
                Rechercher
              </button>
            </div>
          </div>
          <br />
          <div
            style={{
              height: "550px",
              overflowX: "hidden",
              overflowY: "auto",
            }}
          >
            {resultat.length >= 1 && (
              <table className="table">
                {/* <thead>
                  <tr>
                    <th scope="col">Infomation</th>
                  </tr>
                </thead> */}
                <tbody>
                  {resultat.map((r, index) => (
                    <tr key={index}>
                      <td>
                        <p className="font-weight-bold font-italic">
                          {r.nom + "  " + r.prenom + " né(e) le " + r.dateNaiss}
                        </p>
                        <p className="font-weight-bold font-italic">
                          {r.Section_lib}
                        </p>
                        <p>{`Moyenne :${parseFloat(r.Moy).toFixed(
                          2
                        )}  | Mention :${
                          r.Admis == "O" ? " Admis(e)" : " Echoué(e)"
                        }`}</p>

                        <p className="d-flex justify-content-between px-4">
                          {r.Admis == "O" && (
                            <button
                              type="button"
                              class="btn btn-outline-success btn-sm"
                              onClick={() =>
                                generateQR(
                                  "C",
                                  r.Identifiant,
                                  r.nom,
                                  r.prenom,
                                  r.Annee,
                                  r.dateNaiss,
                                  r.lieu,
                                  r.Matricule,
                                  parseFloat(r.Moy).toFixed(2),
                                  r.Section,
                                  r.Session,
                                  r.Section_lib,
                                  r.sexe,
                                  r.Session === "E"
                                    ? r.extraordinaire
                                    : r.ordinaire
                                )
                              }
                            >
                              e-diplôme
                            </button>
                          )}
                          <button
                            type="button"
                            class="btn btn-outline-success btn-sm mr-3"
                            onClick={() =>
                              generateQR(
                                "R",
                                r.Identifiant,
                                r.nom,
                                r.prenom,
                                r.Annee,
                                r.dateNaiss,
                                r.lieu,
                                r.Matricule,
                                parseFloat(r.Moy).toFixed(2),
                                r.Section,
                                r.Session,
                                r.Section_lib,
                                r.sexe,
                                r.Session === "E"
                                  ? r.extraordinaire
                                  : r.ordinaire
                              )
                            }
                          >
                            e-relevé
                          </button>
                        </p>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          {/* <input type="text" name="ch" onChange={(e) => setName(e.target.value)} /> */}
        </div>
        <div className="col-sm-12 col-md-9">
          <object
            id="output"
            type="application/pdf"
            width="100%"
            height="640px"
          >
            <p>
              {/* <a href={`${mysrc}`} id="download-link">
               
              </a> */}
              {/* .{`La Source est :${mysrc}`} */}
            </p>
          </object>
        </div>
      </div>

      {name}
      {/* <button onClick={() => generateQR(name)}> Generate</button>
      <br />
      {imageurl ? <img width="200" height="200" src={imageurl} /> : ""} */}

      {/* <ToastContainer /> */}
    </div>
  );
};

export default Ediplome;
